// extracted by mini-css-extract-plugin
export default {"bx":"multi_bx__7gh7I","label":"multi_label__YSPg-","error":"multi_error__a-65D"};